<template>
  <div class="flex flex-wrap -mb-8 -mr-6 p-8" v-if="items">
    <text-input v-for="(request, key) in items"
                v-bind:key="key"
                class="pb-8 pr-6 w-full lg:w-1/2"
                v-model="request.value"
                :label="request.label"
                :error="form.errors['name.' + key]"
                :required="true"
    />
    <select-dropdown v-model="form.treatment_type_id" :error="form.errors.treatment_type_id" class="pr-6 pb-8 w-full lg:w-1/2"
                     :options="treatmentTypes" label="Treatment type" :required="true"
    />
    <checkbox v-model="form.empty_field" :error="form.errors.empty_field" class="pb-8 pr-6 w-full lg:w-1/2"
              :label="$t('languages.empty_field')"
    />
  </div>
</template>
<script>
import TextInput from '@/Shared/TextInput'
import Checkbox from '@/Shared/Checkbox'
import SelectDropdown from '@/Shared/SelectDropdown'

export default {
  components: {
    TextInput,
    Checkbox,
    SelectDropdown
  },
  props: ['formData', 'treatmentTypes'],
  data() {
    return {
      items: [],
      languages: this.$languages.getLanguages()
    }
  },
  computed: {
    form() {
      return this.formData
    }
  },
  mounted() {
    let formLanguages = this.form.name
    for (let language in this.languages) {
      let obj = {
        id: this.languages[language].value,
        label: this.languages[language].label,
        value: formLanguages[this.languages[language].value] ? formLanguages[this.languages[language].value] : ''
      }
      this.items.push(obj)
    }
  },
  watch: {
    items: {
      handler(newValue) {
        let obj = {}
        for (let item in this.items) {
          obj[this.items[item].id] = this.items[item].value
        }
        this.form.name = obj
      },
      deep: true
    },
  }
}
</script>
